import { CloseRounded } from '@mui/icons-material';
import { Box, IconButton, InputAdornment, TextField } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface ConfigurationStringValueFieldV21Props {
  handleValueChange: (val: string) => void;
  controlerValue: string;
  maxLimit: number;
}

export const ConfigurationStringValueFieldV21: React.FC<
  ConfigurationStringValueFieldV21Props
> = ({ handleValueChange, controlerValue, maxLimit, ...rest }) => {
  const { t } = useTranslation('chargingStations');
  const [helperText, setHelperText] = useState('');

  return (
    <Box sx={{ width: '100%', minWidth: 0, maxWidth: '100%' }}>
      <TextField
        onFocus={() => {
          setHelperText(
            t('maximumCharNumber', {
              maxLimit: maxLimit,
            })
          );
        }}
        onBlur={() => {
          setHelperText('');
        }}
        variant="outlined"
        value={controlerValue}
        placeholder={controlerValue || '-'}
        fullWidth
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                edge="end"
                aria-label="clear"
                sx={{ visibility: controlerValue ? 'visible' : 'hidden' }}
                onClick={() => {
                  handleValueChange('');
                }}
              >
                <CloseRounded />
              </IconButton>
            </InputAdornment>
          ),
        }}
        onChange={(e) => {
          handleValueChange(e.target.value);
        }}
        {...rest}
        helperText={helperText}
        sx={{
          width: '100%',
          minWidth: 0,
          '& .MuiInputBase-root': { minWidth: 0 },
          '& .MuiInputBase-input': {
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          },
          '& .MuiFormHelperText-root': { marginLeft: 0 },
        }}
      />
    </Box>
  );
};
